import { createSelector } from '@reduxjs/toolkit';

import { GlobalState } from '@/redux/store';

const stateSelector = (state: Partial<GlobalState>) => state;
const auctionsNearMeSlice = createSelector(stateSelector, (state) => state.auctionsNearMe);
export const getCatalogIdsSelector = createSelector(auctionsNearMeSlice, ({ catalogIds }) => catalogIds);

export const getCatalogsNearMeSelector = createSelector(
    auctionsNearMeSlice,
    ({ catalogsNearMe }) => catalogsNearMe ?? []
);

export const getRelatedGeoAreasSelector = createSelector(auctionsNearMeSlice, ({ otherPlaces }) => otherPlaces ?? []);

export const getPaginationInfoSelector = createSelector(
    auctionsNearMeSlice,
    ({ currentPage, totalPages, totalRecords }) => ({
        currentPage,
        totalPages,
        totalRecords,
    })
);

export const getMapPointsSelector = createSelector(auctionsNearMeSlice, ({ mapPoints }) => mapPoints ?? []);

export const getNearbyFallbackSelector = createSelector(
    auctionsNearMeSlice,
    ({ nearbyFallback }) => nearbyFallback ?? null
);

export const getTotalUniqueHousesSelector = createSelector(
    auctionsNearMeSlice,
    ({ totalUniqueHouses }) => totalUniqueHouses ?? 0
);

export const getLoadingSelector = createSelector(auctionsNearMeSlice, ({ loading }) => loading);

export const getErrorSelector = createSelector(auctionsNearMeSlice, ({ error }) => error);

export const getInvalidLocationPathSelector = createSelector(
    auctionsNearMeSlice,
    ({ invalidLocationPath }) => invalidLocationPath
);
